import { Button, Group, Paper, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { t } from 'i18next';
import { useState } from 'react';

import { updateDatasetsFiles } from '@mygpt/app';
import { useParams } from 'react-router-dom';

export interface EditFormProps {
  title: string;
  fileId: string;
  onSubmitCallback?: () => void;
}

export const EditForm = ({ fileId, onSubmitCallback, title }: EditFormProps) => {
  const { datasetId } = useParams();

  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      title,
    },
    validate: {
      title: (value) => (value?.trim() ? null : t('fields.title_invalid')),
    },
  });

  const handleSubmit = (values: { title: string }) => {
    setLoading(true);

    updateDatasetsFiles({ datasetId: datasetId || '', id: fileId, title: values.title })
      .then(() => {
        onSubmitCallback && onSubmitCallback();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Paper
      p={0}
      shadow={'none'}
      style={{
        position: 'relative',
      }}
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Group grow>
          <TextInput data-autofocus autoComplete="off" placeholder="Title" {...form.getInputProps('title')} />
        </Group>

        <Group justify="flex-end" mt="xl">
          <Button type="submit" loading={loading}>
            {t('submit')}
          </Button>
        </Group>
      </form>
    </Paper>
  );
};
